// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"654d0dc4","453":"7ac98e5b","455":"64009e21"}[chunkId] + ".chunk.js";
};